<template>
  <div>
    <nav id="navbar">
      <div class="nav">
        <div class="nav-content">
          <div class="nav-icon">
            <router-link to="/">
              <img class="b-logo" src="./../assets/tight.png" alt="Logo" />
            </router-link>
          </div>
          <div class="nav-menu">
            <div class="nav-menu-horiz">
              <div class="nav-item">
                <router-link to="/">NOSOTROS</router-link>
              </div>
              <div class="nav-item">
                <router-link to="/#servicios">SERVICIOS</router-link>
              </div>
               <!--
              <div class="nav-item">
                <router-link to="/Whatsapp">WA</router-link>
              </div>
               -->
              <!--
              <div class="nav-item">
                <router-link to="/Solicitar_QR">SOLICITAR QR</router-link>
              </div>
              -->
              <div class="nav-item">
                <router-link to="/#contacto">CONTACTO</router-link>
              </div>
            </div>
            <div class="dropdown" @click="opened = !opened">
              <button class="dropbtn">
                ...
                <i class="fa fa-caret-down"></i>
              </button>
              <div class="dropdown-content" :class="{'displayBlock': opened}">
                <div class="nav-item">
                  <router-link to="/nosotros">NOSOTROS</router-link>
                </div>
                <div class="nav-item">
                  <router-link to="/#servicios">SERVICIOS</router-link>
                </div>
                <!--
                <div class="nav-item">
                <router-link to="/Solicitar_QR">SOLICITAR QR</router-link>
              </div>
              -->
                <div class="nav-item">
                  <router-link to="/#contacto">CONTACTO</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      opened: false
    };
  }
};
</script>

<style scoped lang="scss">
.nav-content {
  display: inline-block;
  width: 60%;
  padding: 10px;
}
.nav-icon {
  float: left;
}
.nav-menu {
  display: inline-block;
  text-align: right;
  margin: 10;
  float: right;
}
.nav-item {
  float: left;
  padding: 10px 9px 10px 9px;
  margin-right: 20px;
  a {
    &:hover {
      color: #9ed96b !important;
    }
  }
}

.b-logo {
  max-width: 100%;
  height: auto;
  left: 15px;
  width: 58px;
  @media screen and (max-width: 980px){
    width: 70px;
  }
}
.dropdown .dropbtn {
  font-size: 16px;
  border: none;
  outline: none;
  padding: 10px 16px;
}
.dropdown {
  float: right;
  display: none;
}
.dropdown:hover .dropbtn {
  background-color: #9ed96b !important;
}

.dropdown-content {
  overflow: auto;
  height: 202px;
  display: none;
  // position: absolute;
  background-color: #f9f9f9;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  .nav-item {
    float: none;
  }
  max-width: 200px;
}

.dropdown-content a {
  float: none;
  padding: 12px 16px;
  display: block;
  text-align: left;
}

.dropdown-content {
  a:hover {
    background-color: #ddd;
  }
  // a:active{
  //   .dropdown-content {display: none !important}
  // }
}
.nav {

  z-index: 100;
  position: fixed;
  float: right;
  width: 100%;
  height: 8%;
  text-align: center;
  background-color: white;
  @media screen and (max-width: 980px) {
    height: 12%;
    div.nav-menu-horiz {
      display: none;
    }
    div.dropdown {
      display: block !important;
    }
  }
  .displayBlock {
    display: block;
  }
  // @media screen and (max-width: 550px){
  //     div.nav{max-width: 285px !important;}
  //     div.nav-icon{width: 175px;}
  //     div.dropdown-content{position:relative}
  // }
}
</style>
